/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupscreated1Inputs */

const en_groupscreated1 = /** @type {(inputs: Groupscreated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your group is ready.`)
};

const de_groupscreated1 = /** @type {(inputs: Groupscreated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Gruppe ist da.`)
};

/**
* | output |
* | --- |
* | "Your group is ready." |
*
* @param {Groupscreated1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupscreated1 = /** @type {((inputs?: Groupscreated1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupscreated1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupscreated1(inputs)
	return de_groupscreated1(inputs)
});
export { groupscreated1 as "groupsCreated" }